// extracted by mini-css-extract-plugin
export default {"container":"CreatedByField_container__mSece","avatar":"CreatedByField_avatar__Q-x3n"};